<script lang="ts">
    import Tooltip from "../../lib/components/Tooltip.svelte";
    import { batteryHealths } from "../../lib/constants";

    export let battery: {
        level: number;
        isCharging: boolean;
        health: number;
        temperature: number;
    };

    $: levelColor =
        battery.level <= 15
            ? "var(--destructive)"
            : battery.level <= 50
              ? "var(--warning)"
              : "var(--success)";

    $: tempColor =
        battery.temperature >= 50 ? "var(--destructive)" : "var(--success)";
</script>

<div class="inline-flex items-center gap-1.5">
    <Tooltip content={battery.level + "%"}>
        <!-- Battery shape -->
        <div
            class="relative w-7 h-3.5 rounded-sm border border-[var(--border)] bg-[var(--input)]/30 overflow-hidden"
        >
            <div
                class="absolute left-0 top-0 bottom-0 transition-all"
                style="width: {battery.level}%; background: {levelColor};"
            ></div>
        </div>
    </Tooltip>

    {#if battery.isCharging}
        <Tooltip content="Заряжается">
            <svg
                width="11"
                height="11"
                viewBox="0 0 24 24"
                fill="var(--warning)"
                ><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" /></svg
            >
        </Tooltip>
    {/if}

    <Tooltip content={batteryHealths[battery.health] || "?"}>
        <span class="text-[10px]" style="color: {tempColor};"
            >{battery.temperature}°</span
        >
    </Tooltip>
</div>
